import type { ElementType, ReactNode } from "react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { formatArabicNumber } from "@/lib/formatters";

interface SectionHeaderProps {
  title: string;
  icon?: ElementType;
  count?: number | string;
  actions?: ReactNode;
  className?: string;
}

export function SectionHeader({
  title,
  icon: Icon,
  count,
  actions,
  className,
}: SectionHeaderProps) {
  return (
    <div className={cn("flex items-center gap-3", className)}>
      {Icon && (
        <div className="rounded-md bg-primary/10 p-1.5 text-primary shrink-0">
          <Icon className="size-4" />
        </div>
      )}
      <h2 className="text-base font-semibold text-foreground tracking-tight">
        {title}
      </h2>
      {count !== undefined && (
        <Badge variant="secondary" className="rounded-full px-2 tabular-nums">
          {typeof count === "number"
            ? formatArabicNumber(count)
            : count}
        </Badge>
      )}
      <div className="flex-1 h-px bg-border/60" />
      {actions}
    </div>
  );
}
